export const OrientationTypes = {
    PORTRAIT: 'PORTRAIT',
    LANDSCAPE: 'LANDSCAPE'
}

export const ResolutionTypes = {
    SD: 'SD',
    HD: 'HD',
    UHD: 'UHD'
}